import { PressPageTranslations } from "./types";

export const enTranslations: [PressPageTranslations] = [{
    title: "Platform",
    quotes: [{
        subtitle: "Award by German Medical Society",
        description: "DIVINA was awarded the 2020 German Medical Award for its innovative approach to teaching medical students how to manage complex conditions in emergency rooms.",
    }]
}];